import { Component, EventEmitter, Input, Output, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { AbstractValueAccessor, MakeProvider } from '../abstract-value-accessor';

export class Option {
  value: any;
  label: string;

  constructor(id: number, translateKey: string) {
    this.value = id;
    this.label = translateKey;
  }
}

@Component({
    selector: 'app-dropdown-box',
    templateUrl: './dropdown-box.component.html',
    styleUrls: ['./dropdown-box.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [MakeProvider(DropdownBoxComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DropdownBoxComponent extends AbstractValueAccessor {
  @Input() dropdownBoxId: string;
  @Input() errorText = '';
  @Input() options: Option[];
  @Input() invalid = false;
  @Output() valueChanged = new EventEmitter(true);

  writeValue(val: any): void {
    this.value = val;
  }

  dropDownBox($event) {
    if (!this.disabled) {
      this.onChange($event);
      this.onTouch();
      this.valueChanged.emit($event);
    }
  }
}
